import { createContext } from 'react';

export type ConfigType = {
  ikeaDomain: string; // IKEA retail site domain, eg www.ikea.com
  customerAdminDomain: string; // Customer admin domain, eg customeradmin.customer.ingka.com
};

export const ConfigContextDefaults: Readonly<ConfigType> = {
  ikeaDomain: '',
  customerAdminDomain: '',
};

export const ConfigContext = createContext<ConfigType>(ConfigContextDefaults);
